/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_action__retry = /** @type {(inputs: {}) => string} */ () => {
	return `Wiederholen`
};

const en_action__retry = /** @type {(inputs: {}) => string} */ () => {
	return `Retry`
};

const es_action__retry = /** @type {(inputs: {}) => string} */ () => {
	return `Volver a intentar`
};

const fr_action__retry = /** @type {(inputs: {}) => string} */ () => {
	return `Réessayer`
};

const it_action__retry = /** @type {(inputs: {}) => string} */ () => {
	return `Riprova`
};

const nl_action__retry = /** @type {(inputs: {}) => string} */ () => {
	return `Opnieuw proberen`
};

const pt_action__retry = /** @type {(inputs: {}) => string} */ () => {
	return `Tentar novamente`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const action__retry = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.action__retry(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("action__retry", locale)
	if (locale === "de") return de_action__retry(inputs)
	if (locale === "en") return en_action__retry(inputs)
	if (locale === "es") return es_action__retry(inputs)
	if (locale === "fr") return fr_action__retry(inputs)
	if (locale === "it") return it_action__retry(inputs)
	if (locale === "nl") return nl_action__retry(inputs)
	return pt_action__retry(inputs)
};